import { createContext, useContext, useEffect, useState } from "react";
import { BASE_URL } from "../config/config";

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [counts, setCounts] = useState({
    users_count: 0,
    courses_count: 0,
    documents_count: 0,
    current_month_revenue:0,
  });

  const [monthlyUsers, setMonthlyUsers] = useState([]);
  const [monthlyrevenue, setMonthlyRevenue] = useState([]);
  const [notifications, setNotifications] = useState([]);

  const [loading, setLoading] = useState(true);

  const fetchDashboardCounts = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await fetch(`${BASE_URL}/dashboard`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await res.json();

      if (res.ok && result.status) {
        setCounts({
          users_count: result.data.users_count,
          courses_count: result.data.courses_count,
          documents_count: result.data.documents_count,
          current_month_revenue:result.data.current_month_revenue,
        });

        // ✅ STORE MONTHLY USERS DATA
        setMonthlyUsers(result.data.monthly_users_data || []);
        setMonthlyRevenue(result.data.monthly_revenue || []);
        setNotifications(result.data.notifications || []);
      }
    } catch (err) {
      console.error("Dashboard API error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardCounts();
  }, []);

  return (
    <DashboardContext.Provider
      value={{
        counts,
        monthlyUsers, 
        monthlyrevenue,
        notifications,
        loading,
        refreshDashboard: fetchDashboardCounts,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => useContext(DashboardContext);
